import { motion } from "framer-motion";

export default function Oferta({ serviceName }) {
	return (
		<div className="max-w-3xl mx-auto px-6 py-12 text-gray-800">
			<h1 className="text-3xl font-bold text-center mb-8">
				Договор оферты
			</h1>

			<p className="mb-6">
				Настоящая публичная оферта регулирует отношения между сервисом <b>{serviceName}</b> 
				(далее — <b>Исполнитель</b>) и любым дееспособным лицом, принимающим условия оферты 
				(далее — <b>Пользователь</b>).
			</p>

			<section className="mb-6">
				<h2 className="text-xl font-semibold mb-2">01. Общие положения</h2>
				<p className="mb-2">
					1.1. Оферта регулирует порядок предоставления онлайн-сервиса <b>{serviceName}</b>.
				</p>
				<p>
					1.2. Принятие оферты осуществляется путём регистрации и/или оплаты услуг на сайте или в личном кабинете.
				</p>
			</section>

			<section className="mb-6">
				<h2 className="text-xl font-semibold mb-2">02. Описание услуг</h2>
				<p>2.1. Пользователю предоставляется доступ к функционалу сервиса {serviceName}.</p>
				<p>2.2. Сервис может включать: размещение и обработку данных, доступ к AI-моделям, а также инструменты аналитики.</p>
				<p>2.3. Поддержка Пользователей осуществляется через электронную почту или встроенные каналы связи.</p>
			</section>

			<section className="mb-6">
				<h2 className="text-xl font-semibold mb-2">03. Стоимость и оплата</h2>
				<p>3.1. Актуальные тарифы размещаются в личном кабинете и на сайте сервиса.</p>
				<p>3.2. Оплата производится доступными способами, указанными на сайте.</p>
				<p>3.3. Оплата услуг считается акцептом настоящей оферты.</p>
			</section>

			<section className="mb-6">
				<h2 className="text-xl font-semibold mb-2">04. Права и обязанности сторон</h2>
				<p className="font-medium">Исполнитель обязуется:</p>
				<ul className="list-disc list-inside ml-4 mb-4">
					<li>Обеспечить доступ к сервису после подтверждения оплаты.</li>
					<li>Поддерживать работоспособность и доступность сервисов в разумные сроки.</li>
					<li>Оповещать Пользователя о плановых технических работах.</li>
				</ul>
				<p className="font-medium">Пользователь обязуется:</p>
				<ul className="list-disc list-inside ml-4">
					<li>Использовать сервис исключительно в законных целях.</li>
					<li>Не предпринимать действий, направленных на нарушение работы сервиса.</li>
					<li>Не передавать доступ к личному кабинету третьим лицам.</li>
				</ul>
			</section>

			<section className="mb-6">
				<h2 className="text-xl font-semibold mb-2">05. Ограничение ответственности</h2>
				<p>
					5.1. Сервис предоставляется «как есть». Исполнитель не несёт ответственности 
					за перебои в работе, вызванные внешними причинами (провайдеры, сбои оборудования, атаки и др.).
				</p>
				<p>
					5.2. Исполнитель не гарантирует бесперебойную работу сервиса в случае форс-мажорных обстоятельств.
				</p>
			</section>

			<section className="mb-6">
				<h2 className="text-xl font-semibold mb-2">06. Возврат средств</h2>
				<p>6.1. Возврат возможен в течение 3 дней, если услуга не была оказана по вине Исполнителя.</p>
				<p>6.2. Возврат осуществляется в течение 10 рабочих дней после обращения.</p>
				<p>6.3. Возврат производится на реквизиты, с которых была произведена оплата.</p>
			</section>

			<section className="mb-6">
				<h2 className="text-xl font-semibold mb-2">07. Форс-мажор</h2>
				<p>
					7.1. Стороны освобождаются от ответственности за частичное или полное неисполнение обязательств,
					если оно вызвано обстоятельствами непреодолимой силы.
				</p>
			</section>

			<section className="mb-6">
				<h2 className="text-xl font-semibold mb-2">08. Прочие условия</h2>
				<p>8.1. Исполнитель вправе изменять условия оферты без предварительного уведомления.</p>
				<p>8.2. Пользователь обязан самостоятельно отслеживать изменения оферты на сайте.</p>
			</section>

			<section>
				<h2 className="text-xl font-semibold mb-2">09. Контактная информация</h2>
				<p>Email: <a href="mailto:support@example.com" className="text-blue-600 hover:underline">support@example.com</a></p>
				<p>Сайт: <a href="/" className="text-blue-600 hover:underline">{serviceName}</a></p>
			</section>
		</div>
	);
}

